import * as React from "react";

import { Loader } from "@progress/kendo-react-indicators";
import { Button } from "@progress/kendo-react-buttons";
import { getter } from "@progress/kendo-react-common";

import {
    Grid,
    GridColumn,
    GridFilterChangeEvent,
    GridSelectionChangeEvent,
    getSelectedState,
} from "@progress/kendo-react-grid";

import {
    filterBy,
    CompositeFilterDescriptor,
} from "@progress/kendo-data-query";

import OHTobacco from "./OHTobacco";

import { useGetTobaccosQuery } from '../store/sunbright-api';

const DATA_ITEM_KEY = "uid";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const initialFilter: CompositeFilterDescriptor = {
    logic: "and",
    filters: [],
};

const OHTobaccosGrid = (props: any) => {
    const { data: tobaccos, error: tobaccosError, isLoading: tobaccosLoading } = useGetTobaccosQuery("");

    const [gridHeight, setGridHeight] = React.useState<string>("600px");

    React.useEffect(() => {
        window.addEventListener("resize", handleResize);
    }, []);
    React.useEffect(() => {
        setGridHeight((window.innerHeight - 120) + "px");
    }, [tobaccos]);

    const handleResize = () => {
        setGridHeight((window.innerHeight - 100) + "px");
    };

    const [filter, setFilter] = React.useState(initialFilter);

    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});

    const [selectedUID, setSelectedUID] = React.useState<string>("");
    const [selectedRegionID, setSelectedRegionID] = React.useState<string>("");

    const handleSelectionChange = (e: GridSelectionChangeEvent) => {
        const newState = getSelectedState({
            event: e,
            selectedState: selectedState,
            dataItemKey: DATA_ITEM_KEY,
        })
        setSelectedState(newState);
        setSelectedUID(Object.keys(newState)[0]);

        if (e.startDataItem && e.startDataItem.regionID) {
            setSelectedRegionID(e.startDataItem.regionID);
        }
    };


    return (
        <React.Fragment>
            {(selectedUID.length !== 0) ?
                (< OHTobacco
                    eventID={+selectedUID}
                    regionID={+selectedRegionID }
                    onReturn={() => setSelectedUID("")}
                />
                ) :
                (<div>
                    <div className="sds-gridHeader">One Health Tobacco</div>
                    {tobaccosError ? (<>Not Authorized</>) : tobaccosLoading ? <Loader size="large" type="converging-spinner" /> : tobaccos ? (
                        <div>
                            <Grid
                                style={{ height: gridHeight }}
                                className="tobaccosGrid sds-selectable"
                                data={filterBy(tobaccos.map((item: any) => ({
                                    ...item,
                                    [SELECTED_FIELD]: selectedState[idGetter(item)]
                                })), filter)}
                                sortable={true}
                                filterable={true}
                                filter={filter}
                                onFilterChange={(e: GridFilterChangeEvent) => setFilter(e.filter)}
                                resizable={true}
                                reorderable={true}
                                size={"small"}
                                dataItemKey={DATA_ITEM_KEY}
                                selectedField={SELECTED_FIELD}
                                selectable={{
                                    enabled: true,
                                    mode: "single",
                                }}
                                onSelectionChange={handleSelectionChange}
                            >
                                <GridColumn field="startTime" title="Date" format="{0:MMM d yyyy}" filterable={false} />
                                <GridColumn field="host" title="Host/Location" filterable={true} filter="text" />
                                <GridColumn field="region" title="Region" filterable={true} filter="text" />
                            </Grid>
                        </div>
                    ) : null}
                </div>)
            }
        </React.Fragment>
    );
}
export default OHTobaccosGrid;
